<template>
  <div header :class="{sticky}">
    <h1 @click="$router.push('/')">GYNPAD 가인패드</h1>
    <div class="right">
      <s class="handle" @click="openGnb">MENU</s>
      <div class="body hidden-md-down">
        <gnb class=""/>
<!--        <a class="btn black buy" href="http://maps.gynpad.com/map/gynpad_map.asp" target="_blank">구매병원 찾기</a>-->
      </div>
    </div>
    <nav v-if="gnbOpen" class="hidden-lg-up">
      <div class="head">
        <div class="close" @click="closeGnb"></div>
      </div>
      <div class="body">
        <gnb/>
<!--        <a class="btn black buy" href="http://maps.gynpad.com/map/gynpad_map.asp" target="_blank" >구매병원 찾기</a>-->
        <div class="tel">
          <a href="tel:1544-2719">상담전화 1544-2719</a>
        </div>
        <div class="lang">
          <a href="http://gynpadmall.com" target="_blank">구매하기</a>
          <a href="http://gynpadmall.com/hospital/search.html" target="_blank">상담 병원 찾기</a>
        </div>
      </div>
    </nav>
  </div>
</template>

<style lang="less" scoped>
  @import "../less/asset";
  @import "../less/gynpad";

  [header] { background: #fff; .rp-h(29); .rp-t(21); .rh(59); .border-box; .rel;
    h1 { .ir; .rwh(66,22); .contain('@{common}/logo_m.png'); cursor: pointer; }
    .right { .rt-r(29,22);
      .handle { .karla; .rwh(62,14); .border-box; .rp-r(16); .tc; .fsl(1rem,1.2); .bg('@{common}/menu_dot.svg', right, center); .contain; .no-repeat; .rt; }
    }
    nav { .lt; .wf; z-index: 20; .border-b;
      .head { .wf; .rh(65); .rel; background: #fff;
        .close { .contain('@{common}/close_m.svg'); .rwh(16,16); .rt-r(30,30); }
      }
      .body { background: #fff;  .tc;
        .buy { .rw(200); }
        .tel { .rp-v(20); .fs(1.2rem); }
        .lang { .ib-list; .border-t(@c-border, 1px); color:@c-pink;
          a { .rp(25); .border-box; .fsl(1.3rem,1); .ib; .w(50%);}
          a + a { .border-l(@c-border, 1px);}
        }
      }
    }
  }

  @media (min-width: @screen-lg-min) {
    [header] { background: none; .lt(0,40px); padding:0 40px; z-index: 10; .wf; .border-box; height:48px;
      &:before { content: ''; .wh(100%,88px); .lb; opacity: 0; background: #fff; transition: opacity 0.5s; }
      h1 { .contain('@{common}/logo_pc.png'); .wh(113px, 36px); .lt(40px, 6px); }
      .right { .rt(40px, 0);
        .handle { .hide; }
        .body { .ib-list;
          .btn { .im-l(36px); }
        }
      }
      &.sticky { .fix; top:0;
        &:before { opacity:1; }
      }
    }
  }
</style>


<script>
import Gnb from './Gnb.vue';
import { getScrollBody } from '../util';

export default {
  name: 'Header',
  components: { Gnb },
  data() {
    return {
      gnbOpen: false,
      sticky: false,
    };
  },
  watch: {
    $route() {
      this.gnbOpen = false;
    },
  },
  methods: {
    openGnb() {
      this.gnbOpen = true;
    },
    closeGnb() {
      this.gnbOpen = false;
    },
    routed() {

    },
    scroll() {
      this.sticky = (getScrollBody().scrollTop() > 40);
    },
  },
  mounted() {
    window.addEventListener('scroll', this.scroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll);
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Header.vue